import { APIBase } from '@agro1desenvolvimento/apis-js-package';
import { isAxiosError } from 'axios';
import LocalStorageService from './local-storage';
import aqilaApi from './aqila-api';

class ApiGlobalService extends APIBase {
  private readonly API_GLOBAL_BASE_URL = 'https://api.aqila.com.br/';

  constructor() {
    super();
    this.initialize({ baseURL: this.API_GLOBAL_BASE_URL });
  }

  async inicializeApiHostUrl() {
    try {
      const { hostname } = window.location;
      const { data } = await this.get<string>('url', {
        params: { q: hostname },
      });

      LocalStorageService.setItem('apiHostUrl', data);
      aqilaApi.syncBaseUrlFromStorage();
    } catch (error) {
      if (isAxiosError(error) && error.response?.status === 404) {
        const savedUrl = LocalStorageService.getItem('apiHostUrl');
        if (savedUrl) return;
      }

      throw new Error(`Falha ao carregar configuração global: ${error}`);
    }
  }
}

export default new ApiGlobalService();
